import { HttpService } from '@/infra'

export class DeleteReservaProdutoService extends HttpService {
  async execute(idExternoProduto: number) {
    return this.http.delete(`/api/v2/ReservaDoProduto/${idExternoProduto}`)
  }
}
